import { looks } from "../features/looks-gallery/data/looks";
import { makeupBeautyServices } from "../features/beauty-services/data/makeupBeautyServices";
import { fragranceBeautyServices } from "../features/beauty-services/data/fragranceBeautyServices";
import { CSVRow, loadCSVFromFile } from "./csvLoader";

function add(set: Set<string>, url?: string) {
	if (!url) return;
	set.add(url);
}

/**
 * Collects known asset URLs used across the app for preloading.
 * Includes:
 * - Logos and landing videos
 * - Looks gallery images/videos and product images
 * - Beauty services images
 * - Profiler question backgrounds from CSV
 */
export async function collectAllAssetUrls(): Promise<string[]> {
	const urls = new Set<string>();

	// Global/home assets
	add(urls, "/logo.jpg");
	add(urls, "/logo_name.png");

	// Landing videos
	add(urls, "/beauty-profiler/landing-page.mp4");
	add(urls, "/fragrance-profiler/landing-page.mp4");

	// Looks gallery entries
	for (const look of looks) {
		add(urls, look.imagePath);
		add(urls, look.videoPath);
		for (const product of look.products) {
			add(urls, product.imagePath);
		}
	}

	// Beauty services images
	for (const service of makeupBeautyServices) {
		add(urls, service.imagePath);
	}
	for (const service of fragranceBeautyServices) {
		add(urls, service.imagePath);
	}
	// Beauty services home + Looks home
	add(urls, "/looks-gallery/beauty-services/home.jpg");
	add(urls, "/looks-gallery/looks-gallery/home.png");

	// Profiler question backgrounds from CSV
	try {
		const questions: CSVRow[] = await loadCSVFromFile("/data/questions.csv");
		for (const row of questions) {
			add(urls, row.backgroundPath);
		}
	} catch {
		// If CSV isn't available yet, skip silently
	}

	return Array.from(urls);
}


